import React, { FC } from 'react';
import { serverSideTranslation } from '../../../util/next';

import { initSmartSiteData } from '../../../api/smartApi';
import { getPageContent } from '../../../api/pagesApi';

import { SmartPageContainer } from '../../../components/SmartPageContainer';
import NewsFooter from '../../../modules/NewsFooter';

const NewProfessions: FC = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { shareContent = {} } = pageContentData || {};
  const description = shareContent.shareDetail || '发现新职业';
  const title = shareContent.shareTitle || '发现新职业';
  const pageUrl = '/csr/people/new-professions/meituan';

  return (
    <>
      <SmartPageContainer title={title} description={description} pageUrl={pageUrl} {...props} />
      <div className="bg-white">
        <NewsFooter category={1} lanType={i18n.initialLocale} positionNo="csr_5" />
      </div>
    </>
  );
};
export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/csr/people/new-professions',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_ny0cjxtn',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...(await initSmartSiteData(locale)),
      ...(await serverSideTranslation(locale, ['home', 'cookie', 'common'])),
    },
  };
}
export default NewProfessions;
